import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export function DealerDetailsLogo(props) {
  const { logoUrl, dealerWebSite, isMobile } = props;
  return (
    <div className="dealer-logo-wrapper">
      {logoUrl && (
        <div
          className="dealer-details-logo mb-md-0_5 mx-auto"
          style={{
            width: '144px',
            height: '64px',
            marginRight: 'auto!important',
            marginLeft: 'auto!important',
            ...(isMobile ? {} : { marginBottom: '8px!important' }),
          }}
        >
          <img
            className="dealer-details-logo-image"
            src={logoUrl}
            alt="dealer logo"
            style={{ maxHeight: '100%', maxWidth: '100%' }}
          />
        </div>
      )}
      {dealerWebSite && (
        <div className={classNames('hidden-md-down', { 'pt-1': !logoUrl })}>
          <a
            className="dealer-details-web-site-link medium"
            href={dealerWebSite}
            target="_blank"
            rel="noopener noreferrer nofollow"
            data-tracking-id="ddp_dealer_site_clickout"
          >
            Visit dealer’s website&nbsp;
            <span className="icon-new-tab icon-new-tab" aria-hidden />
          </a>
        </div>
      )}
    </div>
  );
}

DealerDetailsLogo.propTypes = {
  logoUrl: PropTypes.string,
  dealerWebSite: PropTypes.string,
  isMobile: PropTypes.bool,
};

DealerDetailsLogo.defaultProps = {
  logoUrl: '',
  dealerWebSite: '',
  isMobile: false,
};
